import type React from 'react';
import { Badge, Box, UnstyledButton } from '@mantine/core';
import type { ActiveTab } from './workspaceNavigationItems';

export type MobileBottomTabItem = {
  value: ActiveTab;
  label: string;
  icon: React.ReactNode;
  badge?: number;
};

type MobileBottomTabBarProps = {
  activeTab: ActiveTab;
  tabs: MobileBottomTabItem[];
  onChange: (value: ActiveTab) => void;
};

export function MobileBottomTabBar({ activeTab, tabs, onChange }: MobileBottomTabBarProps) {
  return (
    <Box
      component="nav"
      aria-label="主导航"
      className="workspace-mobile-bottom-tab"
      hiddenFrom="sm"
    >
      <Box className="workspace-mobile-bottom-tab__items" style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}>
        {tabs.map((tab) => {
          const active = activeTab === tab.value;
          return (
            <UnstyledButton
              key={tab.value}
              className="workspace-mobile-bottom-tab__button"
              data-active={active ? 'true' : 'false'}
              onClick={() => onChange(tab.value)}
              aria-label={tab.badge && tab.badge > 0 ? `${tab.label}，${tab.badge} 条未读` : tab.label}
              aria-current={active ? 'page' : undefined}
            >
              <Box className="workspace-mobile-bottom-tab__icon" aria-hidden="true">
                {tab.icon}
                {tab.badge !== undefined && tab.badge > 0 && (
                  <Badge className="workspace-mobile-bottom-tab__badge" size="xs" color="terracotta" variant="filled">
                    {tab.badge > 99 ? '99+' : tab.badge}
                  </Badge>
                )}
              </Box>

            </UnstyledButton>
          );
        })}
      </Box>
    </Box>
  );
}
